import { isDev } from '../utils/environment';

export const INVOICE_DOWNLOADER_BASE_URL = isDev
  ? 'http://localhost:8082'
  : `${window.origin}/InvoiceDownloader`;

export const ITELLITY_BACKEND_BASE_URL = isDev
  ? 'http://localhost:8080/ItellityWebServices'
  : `${window.origin}/ItellityWebServices`;
